// extracted by mini-css-extract-plugin
export default {"container":"TabsSwitch_container__4bXgg","exteriorButton":"TabsSwitch_exteriorButton__pHCO5","interiorButton":"TabsSwitch_interiorButton__qKWm8"};